export default "__VITE_ASSET__Dib6WYDj__"